import { GroupSummary } from '../dtos/group-summary';
import { CreateExamDTO } from '$synapse/dtos';

export class CandidateCreationDescriptor {
  firstName: string;
  lastName: string;
  email: string;
  exams?: CreateExamDTO[];
  groups?: GroupSummary[];

  constructor(
    firstName: string,
    lastName: string,
    email: string,
    initialExams?: CreateExamDTO[],
    groups?: GroupSummary[]
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.groups = groups;
    this.exams = initialExams;
  }
}
